import React from "react";

import { cn } from "@/utils/general";

import styles from "./Section.module.scss";

interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  maxWidth?: number | string;
  px?: string;
  py?: string;
  my?: string;
  useMargin?: boolean;
  className?: string;
  children?: React.ReactNode;
  withBottomLine?: boolean;
  withBottomLineDesktop?: boolean;
  bannerOverlay?: boolean;
}

const Section: React.FC<SectionProps> = ({
  maxWidth = 1600,
  px = `px-[24px] md:px-[32px] lg:px-[48px] xl:px-[112px]`,
  py = `py-[40px] md:py-[48px] lg:py-[80px]`,
  my = `my-[40px] md:my-[48px] lg:my-[80px]`,
  useMargin = false,
  className = "",
  children,
  bannerOverlay = false,
  ...restProps
}) => {
  const bannerOverlayClasses = bannerOverlay
    ? "!pt-0 -mt-10 md:-mt-12 lg:-mt-20 relative z-10"
    : "";

  return (
    <>
      <section
        data-section // need attribute for use-sticky-navigation
        className={cn(
          "w-full mx-auto",
          `max-w-[${maxWidth}px]`,
          !useMargin ? py : "py-0",
          useMargin ? my : "my-0",
          px,
          bannerOverlayClasses,
          className,
          "nova-section"
        )}
        {...restProps}
      >
        {children}
      </section>
      {restProps?.withBottomLine && <div className={styles.sectionLine} />}
      {restProps?.withBottomLineDesktop && (
        <div className={cn(styles.sectionLine, "lg:block hidden")} />
      )}
    </>
  );
};

export default Section;
